/**
 * Nav Toggle - Replaces Webflow's w-nav-button functionality
 * This script handles mobile menu toggle for converted Webflow themes
 */
document.addEventListener('DOMContentLoaded', function() {
  // Find all menu buttons (various class names used in Webflow)
  const menuButtons = document.querySelectorAll('.w-nav-button, .menu-button, .menu-button-2');
  const navMenus = document.querySelectorAll('.w-nav-menu, .navigation-items');
  const navContainer = document.querySelector('.w-nav');

  menuButtons.forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();

      // Toggle open state on button
      this.classList.toggle('w--open');

      // Toggle open state on nav menus
      navMenus.forEach(menu => {
        menu.classList.toggle('w--open');
      });

      // Toggle open state on nav container if it exists
      if (navContainer) {
        navContainer.classList.toggle('w--open');
      }
    });
  });

  // Close menu when clicking outside
  document.addEventListener('click', function(e) {
    const isMenuButton = e.target.closest('.w-nav-button, .menu-button, .menu-button-2');
    const isInsideMenu = e.target.closest('.w-nav-menu, .navigation-items');

    if (!isMenuButton && !isInsideMenu) {
      menuButtons.forEach(btn => btn.classList.remove('w--open'));
      navMenus.forEach(menu => menu.classList.remove('w--open'));
      if (navContainer) navContainer.classList.remove('w--open');
    }
  });

  // Close menu when pressing Escape
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      menuButtons.forEach(btn => btn.classList.remove('w--open'));
      navMenus.forEach(menu => menu.classList.remove('w--open'));
      if (navContainer) navContainer.classList.remove('w--open');
    }
  });
});
